
import { StringField } from '../../../types/types';
import { TExploreEquipmentFields, TExploreEquipmentProps, TProductLinesData} from '../types/ExploreEquipment.types';
import mock from '../../../mocks/ExploreEquipment.mock';

export class ExploreEquipmentModel {
  private readonly fields: null | TExploreEquipmentFields;
  constructor(props: TExploreEquipmentProps) {
    this.fields = props.fields || null;
  }

  get title(): StringField {
    return this.fields?.itemData?.fields?.Title ?? mock.fields.itemData.fields.Title;
  }

  get productListData(): TProductLinesData | undefined {
    return this.fields?.apiData;
  }

  get url(): string {
    return this.fields?.itemData?.contextItemUrl ?? mock.fields.itemData.contextItemUrl;
  }
}